import {
  faLongArrowDown,
  faLongArrowUp,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function Sort({ sortAscending, onSort }) {
  return (
    <button
      onClick={onSort}
      className="text-xs md:text-sm h-6 text-brand border-brand hover:bg-brand-subtle rounded-full px-2 border whitespace-nowrap"
      data-testid="date-sort-button"
    >
      {!sortAscending ? "Oldest " : "Newest "}
      <FontAwesomeIcon
        icon={!sortAscending ? faLongArrowDown : faLongArrowUp}
      />
    </button>
  );
}
